import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AdsTraffic } from '../models/ads-traffic';
import { ApiResponse } from '../models/api-response';
import { AdsSummary } from '../models/ads-summary';

@Injectable({
  providedIn: 'root',
})
export class AdsService {
  baseApi = environment.baseCloud7CmsApiUrl + '/api';

  constructor(private http: HttpClient) { }

  getAdsTraffics(
    operator: string,
    merchant: string, fromDate?: Date, toDate?: Date) {  
    return this.http.get<ApiResponse<AdsTraffic[]>>(
      this.baseApi + '/Ads/traffic?merchant=' + merchant + '&operator=' + operator+'&fromDate='+fromDate?.toDateString() +'&toDate=' + toDate?.toDateString()
    );
  }

  getAdsSummaries( 
    merchant: string, fromDate?: Date, toDate?: Date) {     
    return this.http.get<ApiResponse<AdsSummary[]>>(
      this.baseApi + '/Ads/summaries?merchant=' + merchant +'&fromDate='+fromDate?.toDateString() +'&toDate=' + toDate?.toDateString()
    );
  }

  private getOperatorHeader(operator: string) {
    const headers = new HttpHeaders({ Operator: operator });
    return headers;
  }
}
